var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadRequestIcon = function SvgBadRequestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 240 240"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#606B76",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#BadRequestIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.994,
    cy: 120.002,
    r: 86.4,
    fill: "#606B76",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#606B76",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.2,
    strokeWidth: 7.5,
    d: "m90 150 60-60m-60 0 60 60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "BadRequestIcon_svg__a",
    width: 223.197,
    height: 223.201,
    x: 8.394,
    y: 8.402,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.283333 0 0 0 0 0.31875 0 0 0 0 0.354167 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6145_69807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6145_69807",
    result: "shape"
  })))));
};
export default SvgBadRequestIcon;